import LegalDocumentPage from "../components/legal/LegalDocumentPage";

const PrivacyPolicy = () => <LegalDocumentPage documentKey="privacyPolicy" />;

export default PrivacyPolicy;
